function camelToUnderscore(key) {
    return key
        .replace(/\W+/g, ' ')
        .split(/ |\B(?=[A-Z])/)
        .map(function (word) { return word.toLowerCase(); })
        .join('_');
}
export default camelToUnderscore;
//# sourceMappingURL=camelToUnderscore.js.map